import {
  APIProvider,
  InfoWindow,
  Map,
  Marker,
} from "@vis.gl/react-google-maps";
import { Spin } from "antd";
import { GOOGLE_API_KEY } from "constants/common";
import useSosTracking from "hooks/soses/useSosTracking";
import moment from "moment";
import { Polyline } from "pages/TripPages/TripRoute/polyline";

export default function SosTracking() {
  const { currentLocation, data, location, setLocation } = useSosTracking();

  return (
    <div className="w-full h-screen">
      {!data?.id ? (
        <div className="w-full h-full grow flex items-center justify-center">
          <Spin size="large" />
        </div>
      ) : (
        <APIProvider apiKey={GOOGLE_API_KEY}>
          <Map defaultZoom={16} {...currentLocation}>
            {data?.locations.map((location, key) => (
              <>
                <Marker
                  onMouseOver={() => setLocation(location)}
                  onMouseOut={() => setLocation(null)}
                  key={key}
                  optimized
                  position={{
                    lat: location.latitude,
                    lng: location.longitude,
                  }}
                />
              </>
            ))}
            {location && (
              <InfoWindow
                position={{
                  lat: location.latitude + 0.0001,
                  lng: location.longitude,
                }}
                headerDisabled
              >
                <div className="text-base">
                  <span className="font-semibold">
                    {moment(location.created_at).format("HH:mm:ss")}
                  </span>
                </div>
              </InfoWindow>
            )}
            <Polyline
              path={
                data?.locations.map((value) => ({
                  lat: value.latitude,
                  lng: value.longitude,
                })) ?? []
              }
              strokeColor="#581845"
              strokeOpacity={1.0}
              strokeWeight={4}
            />
          </Map>
        </APIProvider>
      )}
    </div>
  );
}
